<style scoped lang="less">
  .form-card {
    background: #fff;
    margin-bottom: 24px;
    &-title {
      height: 55px;
      line-height: 55px;
      padding-left: 32px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid #e9e9e9;
    }
    &-content {
      padding: 24px;
    }
  }

  .form-bottom-tool {
    padding: 16px 32px;
    background: #fff;
    border-top: 1px solid #E8E8E8;
  }
  .container{
    height:360px;
    width: 640px;
    //transform: scale(.4) translate(-75%,-75%);
    position: relative;
    overflow: hidden;
    &>.background{
      pointer-events: none;
      width: 100%;
      height: 100%;
      border:1px solid #ddd;
    }
    &>.video{
      &[src=""]{
        //background: #ccc;
      }
      width:100%;
      height:100%;
      position: absolute;
      cursor: move;
      background:#000;
    }
  }
</style>
<template>
  <div>
    <Form ref="formValidate" :model="form" :rules="ruleValidate" :label-width="80" style="padding:24px;width:100%">
      <div class="form-card">
        <div class="form-card-title">目标文件</div>
        <div class="form-card-content">
          <RadioGroup v-model="form.sourceType" vertical :style="{width:'100%'}">
            <Radio label="url" :style="{marginBottom:'15px'}">
              <FormItem props="url" label="URL" :style="{display:'inline-block', width:'80%'}">
                <Input v-model="form.sourceUrl"
                  placeholder="请输入目标文件地址"
                  :disabled="form.sourceType==='file'"
                  @change="loadImage"
                 ></Input>
              </FormItem>
            </Radio>
            <Radio label="file" style="height: auto;">
              <FormItem label="上传" prop="format" :style="{display:'inline-block', width:'80%'}">
                <Upload ref="source" :action="uploadUrl"
                  :on-success="uploadSourceSuccess"
                >
                  <Button type="ghost" icon="ios-cloud-upload-outline" :disabled="form.sourceType==='url'">上传</Button>
                </Upload>
              </FormItem>
            </Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">替换背景</div>
        <div class="form-card-content">
          <RadioGroup v-model="form.backgroundType" vertical :style="{width:'100%'}">
            <Radio label="url" :style="{marginBottom:'15px'}">
              <FormItem props="url" label="URL" :style="{display:'inline-block', width:'80%'}">
                <Input v-model="form.backgroundUrl" placeholder="请输入目标文件地址" :disabled="form.backgroundType==='file'"></Input>
              </FormItem>
            </Radio>
            <Radio label="file" style="height: auto;">
              <FormItem label="上传" prop="format" :style="{display:'inline-block', width:'80%'}">
                <Upload ref="background" :action="uploadUrl"
                    :on-success="uploadBackgroundSuccess"
                >
                  <Button type="ghost" icon="ios-cloud-upload-outline" :disabled="form.backgroundType==='url'">上传</Button>
                </Upload>
              </FormItem>
            </Radio>
          </RadioGroup>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">坐标</div>
        <div class="form-card-content">
          <Row>
            <Col span="6">
              <FormItem label="x" prop="x">
                <InputNumber v-model="form.x" placeholder="请输入x"></InputNumber>
              </FormItem>
              <FormItem label="y" prop="y">
                <InputNumber v-model="form.y" placeholder="请输入y"></InputNumber>
              </FormItem>
              <FormItem label="w" prop="w">
                <InputNumber v-model="form.w" placeholder="请输入w"></InputNumber>
              </FormItem>
              <FormItem label="h" prop="h">
                <InputNumber v-model="form.h" placeholder="请输入h"></InputNumber>
              </FormItem>
            </Col>
            <Col span="18">
              <div class="container" ref="previewContainer">
                <video class="background" :src="backgroundUrl || 'data:video/mp4;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'" />
                <video class="video"
                       v-if="inputUrl && /\.mp4$/.test(inputUrl)"
                      :src="inputUrl"
                      :style="position"
                       @mousedown="handleDragStart"
                       @mousemove="handleDrag"
                />
                <img class="video"
                     v-else-if="inputUrl"
                     :draggable="false"
                     :src="inputUrl"
                     :style="position"
                     @mousedown="handleDragStart"
                     @mousemove="handleDrag"
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div class="form-card">
        <div class="form-card-title">输出设置</div>
        <div class="form-card-content">
          <FormItem props="name" label="输出名称" prop="name">
            <Input v-model="form.name" placeholder="请输入输出名称" style="width: 320px"></Input>
          </FormItem>
        </div>
      </div>
    </Form>
    <div class="form-bottom-tool">
      <Button type="primary" @click="submitForm">提交</Button>
    </div>
  </div>
</template>
<script>
  import {
    UPLOAD_URL,
    GET_TASK,
    CREATE_TASK
  } from '@/utils/api';

  const bgWidth = 640;
  const bgHeight = 360;

  export default {
    data() {
      return {
        data: [],
        scale:1,
        uploadUrl: UPLOAD_URL,
        background:'',
        isDragging:false,
        originalX:0,
        originalY:0,
        positionX:0,
        positionY:0,
        imageWidth:0,
        imageHeight:0,
        form: {
          name:'',
          sourceType: 'url',
          sourceFile: '',
          sourceUrl: '',
          backgroundType: 'url',
          backgroundFile: '',
          backgroundUrl: '',
          x: 0,
          y: 0,
          //1280 * 720
          w: bgWidth,
          h: bgHeight
        },
        urls: [ "" ],
        ruleValidate: {
          name:[{
             required: true, message: '名称不能为空', trigger: 'blur'
          }]
        },
      };
    },
    mounted() {
      //this.getTask()
    },
    computed:{
      backgroundUrl(){
        return this.form.backgroundType === 'url'?this.form.backgroundUrl:this.form.backgroundFile
      },
      inputUrl(){
        return this.form.sourceType === 'url'?this.form.sourceUrl:this.form.sourceFile
      },
      position(){
        const {
          w=0,h=0,x=0,y=0
        } = this.form
        return {
          width: w / this.scale + 'px',
          height: h / this.scale + 'px',
          left: x / this.scale + 'px',
          top: y / this.scale + 'px'
        }
      }
    },
    watch:{
      backgroundUrl(value){
        if(value){
          const v = document.createElement('video')
          v.onloadeddata = this.onImageLoaded
          v.src = value
        }
      }
    },
    methods: {
      handleDragStart(e){
        this.isDragging = true
        this.originalX = e.clientX
        this.originalY = e.clientY
        //this.positionX = this.form.x
        //this.positionY = this.form.y
        // document.addEventListener('mousemove', this.handleDrag)
        // document.addEventListener('mouseup', this.handleDragEnd)
      },
      handleDrag(e){
        if (!this.isDragging) return
        const deltaX = e.clientX - this.originalX
        const deltaY = e.clientY - this.originalY

        this.originalX = e.clientX
        this.originalY = e.clientY

        //this.form.x = Math.min(Math.max(this.form.x + deltaX,0),bgWidth - this.form.w)
        //this.form.y = Math.min(Math.max(this.form.y + deltaY,0),bgHeight - this.form.h)

        this.form.x = Math.floor(Math.max(this.form.x + deltaX * this.scale,0))
        this.form.y = Math.floor(Math.max(this.form.y + deltaY * this.scale,0))
      },
      handleDragEnd(){
        this.isDragging = false
        // document.addEventListener('mousemove', this.handleDrag,false)
        // document.addEventListener('mouseup', this.handleDragEnd,false)
      },
      loadImage(){
        let v = document.createElement('video')
        let that = this
        v.addEventListener('canplaythrough', function(e){
          that.onImageLoaded.call(this,e)
          v.onload = null
          v = null
        })
        v.src = this.inputUrl
      },
      onImageLoaded(e){
        const elm = e.currentTarget
        this.scale = Math.max(elm.videoWidth/bgWidth,elm.videoHeight/bgHeight)

        this.form.w = elm.videoWidth
        this.form.h = elm.videoHeight
      },
      uploadSourceSuccess(response, file, fileLis) {
        this.form.sourceFile = file.response.data
        this.$refs.source.fileList = [file]
        this.loadImage()
      },
      uploadBackgroundSuccess(response, file, fileLis) {
        this.form.backgroundFile = file.response.data
        this.$refs.background.fileList = [file]
      },
      getTask() {
        this.$http.get(GET_TASK)
          .then((response) => {
            const {code, data, errorMessage} = response.body;
            if (code === 0) {
              this.data = data;
            } else {
              this.$Message.error(errorMessage)
            }
          })
      },
      submitForm() {
        this.$refs.formValidate.validate((valid) => {
            if (valid) {
              if (this.inputUrl && this.backgroundUrl) {
                this.$http.post(CREATE_TASK, {
                  input_url: this.inputUrl,
                  mode: /\.gif$/.test(this.inputUrl)?4:3, // 模式 3 扣图 6 格式化
                  background_url: this.backgroundUrl,
                  name:this.form.name,
                  rect: {
                    x: this.form.x,
                    y: this.form.y,
                    w: this.form.w,
                    h: this.form.h
                  }
                }).then(({data})=>{
                  if(data.code === 0){
                    this.$Message.success('保存成功')
                    this.$router.push('/cutout/list')
                  }else{
                    this.$Message.error(data.errorMessage)
                  }
                })
              }
            }
        })

      }
    },
    destroyed(){
      document.body.removeEventListener('mouseup',this.handleDragEnd,false)
    },
    mounted(){
      //防止移出目标区域鼠标未松开导致无法重置
      document.body.addEventListener('mouseup',this.handleDragEnd,false)
    }
  };
</script>
